
const OSS = require('ali-oss')
import request from '@/utils/request.js'
export function client(data) {
  // 后台返回数据
  return new OSS({
    region: data.region,
    accessKeyId: data.accessKey,
    accessKeySecret: data.accessKeySecret,
    stsToken: data.securityToken,
    bucket: data.bucket
  })
}

// 获取阿里云配置信息
export function getUploadInfo(data) {
  return new Promise((resolve, reject) => {
    request.get('/adks-app/uploadconfig/getByTenantId', data).then(res => {
      resolve(res)
    }).catch(error => {
      reject(error)
    })
  })
}

// 获取阿里云配置信息
export function resourceCheckMd5(data) {
  return new Promise((resolve, reject) => {
    request.postdata('/adks-app/resource/check', data).then(res => {
      resolve(res)
    }).catch(error => {
      reject(error)
    })
  })
}

// 根据租户id查询文件上传规则
export function getByTenantId(data) {
  return new Promise((resolve, reject) => {
    request.get('/adks-app/tenantrules/getByTenantId', data).then(res => {
      resolve(res)
    }).catch(error => {
      reject(error)
    })
  })
}

// 上传馆藏
export function collectionUpload(data) {
  return new Promise((resolve, reject) => {
    request.postdata('/adks-app/collection/upload', data).then(res => {
      resolve(res)
    }).catch(error => {
      reject(error)
    })
  })
}

// 上传馆藏
export function ossUpload(data) {
  return new Promise((resolve, reject) => {
    request.postDataWithHeader('/adks-app/oss/upload', data, { 'Content-Type': 'multipart/form-data' }).then(res => {
      resolve(res)
    }).catch(error => {
      reject(error)
    })
  })
}
